module.exports = __webpack_public_path__ + "img/bus_ac_wc.51fc4f43.png";